import { render } from "./FR_results.vue?vue&type=template&id=2c52a690"
import script from "./FR_results.vue?vue&type=script&lang=js"
export * from "./FR_results.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__